<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :search.sync="searchForm"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      :upload-before="uploadBefore"
      :upload-error="uploadError"
      :upload-after="uploadAfter"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="dateStartRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.buyStartTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.buyStartTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="dateEndRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.buyEndTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.buyEndTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="payTimeRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.payTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
    <template slot="menu" slot-scope="scope">
      <el-button
          size="small"
          type="text"
          icon="el-icon-edit"
          @click="openFormDialog(scope.row,'edit')"
        >
          编 辑
        </el-button>
    </template>
      <template slot="infoForm" slot-scope="scope">
        <avue-crud :option="infoOption"                        :data="infoData"></avue-crud>
      </template>
      <template slot-scope="scope" slot="carNoForm">
        <el-autocomplete
          style="width: 100%"
          v-model="form.carNo"
          :debounce="1000"
          @input="carNohandleBlur"
          placeholder="请输入车牌号"
          :trigger-on-focus="true"
          :disabled="dialogDisabled"
          :fetch-suggestions="queryCarPayMonthCarNo"
          @select="selectCarPayCarNo"
        ></el-autocomplete>
      </template>
      <template slot-scope="scope" slot="spaceIdForm">
        <el-select
          :disabled="dialogDisabled"
          v-model="form.spaceId"
          filterable
          placeholder="请选择停车场"
          style="width: 100%"
          @input="selectSpace"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
<!--        <el-button-->
<!--          size="small"-->
<!--          type="primary"-->
<!--          icon="el-icon-plus"-->
<!--          v-if="permission.carmonth_review"-->
<!--          @click="openCarMonthReviewDialog"-->
<!--        >-->
<!--          审 核-->
<!--        </el-button>-->
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permission.carmonth_change"
          @click="openCarMonthChangeDialog"
        >
          车牌变更
        </el-button>
        <el-button
          type="success"
          size="small"
          icon="el-icon-check"
          v-if="permission.carmonth_synchronize"
          @click="openCarMonthSynDialog"
        >
          同 步
        </el-button>
        <el-button
          type="success"
          size="small"
          icon="el-icon-check"
          v-if="permission.carmonth_synchronize_plus"
          @click="carMonthSyncPlus"
        >一 键 同 步
        </el-button>
        <el-button
          type="danger"
          size="small"
          plain
          icon="el-icon-delete"
          v-if="permission.carmonth_refund"
          @click="openCarMonthRefundDialog"
        >
          退款
        </el-button>

        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="downloadTemplate"
          v-if="isAdmin()"
        >下载月卡车模板
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload2"
          @click="openMonthCarEmportForm"
          v-if="isAdmin()"
        >初始化导入月卡车
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="openExportExcelDialog">
          导 出
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permissionList.copyBtn"
          @click="openCarmonthCopyDialog"
        >
          复 制
        </el-button>
      </template>
    </avue-crud>
    <carmonthReniorForm ref="carmonthReniorForm" @onLoad="onLoad"></carmonthReniorForm>
    <el-dialog
      title="月卡车审核"
      :visible.sync="carMonthReviewShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthReviewFormRef"
          v-model="carMonthReviewForm"
          :option="carMonthReviewOption"
          @reset-change="carMonthReviewReset"
          @submit="carMonthReviewSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="rejectCarMonthReviewDialog">驳回</el-button>
            <el-button @click="quitCarMonthReviewDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="月卡车牌变更"
      :visible.sync="carMonthChangeShowDialogFlag"
      :modal-append-to-body="false"
      @opened="carMonthChangeDialogOpened"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthChangeFormRef"
          v-model="carMonthChangeForm"
          :option="carMonthChangeOption"
          @reset-change="carMonthChangeReset"
          @submit="carMonthChangeSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthChangeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="月卡车退费"
      :visible.sync="carMonthRefundShowDialogFlag"
      :modal-append-to-body="false"
      @opened="carMonthRefundDialogOpened"
      @close="quitCarMonthRefundDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthRefundFormRef"
          v-model="carMonthRefundForm"
          :option="carMonthRefundOption"
          @reset-change="carMonthRefundReset"
          @submit="carMonthRefundSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthRefundDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog title="按条件导出" append-to-body :visible.sync="exportExcelFlag">
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>
    <el-dialog
      title="月卡车复制"
      :visible.sync="carMonthCopyShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthCopyFormRef"
          v-model="carMonthCopyForm"
          :option="carMonthCopyOption"
          @reset-change="carMonthCopyReset"
          @submit="carMonthCopySubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthCopyDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <carMonthExport
      ref="carMonthExport"
      v-bind:spaceList="spaceList"
      v-bind:statusList="statusList"
      v-bind:carTypeList="carTypeList"
    >
    </carMonthExport>
    <el-dialog
      title="临停车欠费记录"
      append-to-body
      :visible.sync="tempStopUnPayDialogFlag"
      @closed="closeDialog"
    >
      <avue-crud :option="unPayOption" :data="unPayData" ref="unPayFormRef"/>
    </el-dialog>

    <el-dialog
      title="导入月卡车"
      :visible.sync="showImportDialog"
      v-if="showImportDialog"
      :modal-append-to-body="false"
      width="600px"
      id="month-car-upload"
    >
      <el-form ref="importMonthCarForm" :model="importMonthCarForm" label-width="150px"
               :rules="importMonthCarFormRules">
        <el-row>
          <el-col span="24">
            <el-form-item label="请选择停车场" prop="parkId" id="importMonthCarForm">
              <el-select
                v-model="importMonthCarForm.parkId"
                filterable
                placeholder="请选择停车场"
                style="width: 90%"
              >
                <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="导入Excel" prop="fileName">
              <el-upload
                accept=".xls, .xlsx"
                limit="1"
                style="display: inline-block; vertical-align: top;width: 100%;height:60px"
                ref="upload"
                :disabled="selectFileDisabled"
                action=""
                :auto-upload="false"
                :http-request="exportMonthCar"
                :on-success="uploadImgSuccess"
                :on-change="loadJsonFromFile"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary" :disabled="selectFileDisabled">请选择文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px;">
          <el-col offset="16">
            <el-button
              type="primary"
              :disabled="importButtonDisabled"
              size="small"
              icon="el-icon-check"
              @click="uploadMonthCar"
              style="width: 72px; height: 36px;"
            >确认
            </el-button>
            <el-button
              size="small"
              :disabled="importButtonDisabled"
              @click="cancelUploadMonthCar"
              icon="el-icon-close"
              style="width: 72px; height: 36px;"
            >取消
            </el-button>
          </el-col>
        </el-row>
        <el-row></el-row>
      </el-form>
    </el-dialog>
  </basic-container>
</template>
<script>
  import {
    addRenior,
    getDetailAndOperate,
    getcarMonthLastEndTime,
    getMainList,
    remove,
    synchronize,
    synchronizePlus,
    update,
    loadCarPayBackAmount,
    loadCarPayAmount,
    getDetail,
    copyCarmonth,
    loadCarPayMonthCarNo,
    nodeTreeByParentId,
    getListTempStopUnPayList,
    exportMonthCarList,
  } from '@/api/v4ward/car/carmonth';
  import {getToken} from '@/util/auth';
  import {monthChargeRuleList} from '@/api/v4ward/car/carmonthchargerule';
  import {getSpaceTree} from '@/api/v4ward/car/carparkspace';
  import {lazyBasePropertyTree} from '@/api/v4ward/property/baseproperty';
  import {mapGetters} from 'vuex';
  import carMonthRenewOption from './carmonth-renew-option';
  import carMonthReviewOption from './carmonth-review-option';
  import exportExcelOption from './carmonth-exportExcel';
  import carMonthPayOption from './carmonth-pay-option';
  import carMonthChangeOption from './carmonth-change-option';
  import carMonthRefundOption from './carmonth-refund-option';
  import carMonthExport from './carMonthExport';
  import carMonthCopyOption from './carmonthRenior-copyCarmonth';
  import {getDetailById} from '@/api/v4ward/car/carpark';
  import carmonthReniorForm from "./carmonthRenior-form.vue"
  export default {
    data() {
      return {
        dialogType:'add',
        searchForm:{},

        importMonthCarForm: {
          parkId: '',
          fileName: '',
        },
        importMonthCarFormRules: {
          parkId: [{required: true, message: '请选择车场', trigger: 'change'}],
          fileName: [{required: true, message: '请选择月卡车文件', trigger: 'change'},
            {required: true, message: '请选择月卡车文件', trigger: 'blur'}],
        },
        showImportDialog: false,
        importButtonDisabled: false,
        selectFileDisabled: false,
        dialogDisabled: false,
        reWrite: false,
        exportExcelFlag: false,
        exportExcelOption: exportExcelOption,
        exportExcelForm: {},
        tempStopUnPayDialogFlag: false,
        areaName: '',
        refundCheckBuyEndTime: true,
        refundCheckReturnMoney: true,

        iscarMonthRenewDialogFirstOpen: true,
        carMonthRenewShowDialogFlag: false,
        carMonthRenewForm: {},
        carMonthRenewOption: carMonthRenewOption,

        iscarMonthReviewDialogFirstOpen: true,
        carMonthReviewShowDialogFlag: false,
        carMonthReviewForm: {},
        carMonthReviewOption: carMonthReviewOption,

        iscarMonthPayDialogFirstOpen: true,
        carMonthPayShowDialogFlag: false,
        carMonthPayForm: {},
        carMonthPayOption: carMonthPayOption,

        iscarMonthChangeDialogFirstOpen: true,
        carMonthChangeShowDialogFlag: false,
        carMonthChangeForm: {},
        carMonthChangeOption: carMonthChangeOption,

        iscarMonthRefundDialogFirstOpen: true,
        carMonthRefundShowDialogFlag: false,
        carMonthRefundForm: {},
        carMonthRefundOption: carMonthRefundOption,

        iscarMonthCopyDialogFirstOpen: true,
        carMonthCopyShowDialogFlag: false,
        carMonthCopyForm: {},
        carMonthCopyOption: carMonthCopyOption,
        regionFirstIdTemp: '',
        addFlag: false,

        buyStartTimeTemp: '',
        buyEndTimeTemp: '',
        changeBuyEndTime: false,

        form: {},
        query: {
          spaceId: '',
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        carNoList: [],
        selectionList: [],
        spaceList: [],
        statusList: [],
        carTypeList: [],
        firstDisplayFlag: false,
        tempSpaceId: '',
        option: {
          height: 'auto',
          searchShow: true,
          searchMenuSpan: 6,
          calcHeight: 120,
          align: 'center',
          indexLabel: '序号',
          tip: false,
          border: true,
          editBtn:false,
          index: true,
          viewBtn: true,
          delBtn: true,
          selection: true,
          menuWidth: 200,
          columnBtn: false,
          refreshBtn: false,
          column: [
            {
              label: '车场名称',
              type: 'tree',
              prop: 'spaceId',
              formslot: true,
              editDisabled: false,
              clearable: false,
              span: 8,
              search: true,
              cell: true,
              props: {
                label: 'title',
                value: 'key',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车场名称',
                  trigger: 'change',
                },
              ],
              dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            },
            {
              label: '区域',
              prop: 'regionsName',
              span: 8,
              display: false,
            },

            {
              label: '车牌号',
              prop: 'carNo',
              search: true,
              editDisabled: true,
              formslot: true,
              filterable: false,
              span: 8,
              rules: [
                {
                  required: true,
                  message: '请选择车牌号',
                  trigger: 'change',
                },
                {
                  pattern: this.$validation.carPlate,
                  message: '车牌号格式错误',
                  trigger: 'blur',
                },
              ],
            },
            {
              label: '通行区域',
              prop: 'regions',
              hide: true,
              span: 8,
              type: 'tree',
              multiple: true,
              checkStrictly: true,
              dataType: 'string',
              dicData: [],
              props: {
                label: 'title',
                value: 'id',
              },
              rules: [
                {
                  required: true,
                  message: '请选择通行区域',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车辆分类',
              span: 8,
              hide: true,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车辆分类',
                  trigger: 'change',
                },
              ],
              dataType: 'number',
              prop: 'carClass',
            },
            {
              label: '车辆类型',
              span: 8,
              hide: true,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              prop: 'carType',
              rules: [
                {
                  required: true,
                  message: '请选择车辆类型',
                  trigger: 'blur',
                },
              ],
            },
            {
              label: '上次止期',
              prop: 'lastEndTime',
              span: 8,
              width: 100,
              type: 'date',
              hide: true,
              editDisplay: false,
              viewDisplay: false,
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              disabled: true,
            },
            {
              label: '欠费金额',
              prop: 'backAmount',
              editDisplay: false,
              viewDisplay: false,
              disabled: true,
              hide: true,
              span: 8,
              click: ({value, column}) => {
                let spaceId = this.form.spaceId;
                let carNo = this.form.carNo;
                if (value > 0) {
                  this.selectTempStopUnPayList(spaceId, carNo);
                }
              },
            },
            {
              label: '租赁起期',
              prop: 'buyStartTime',
              span: 8,
              width: 100,
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              rules: [
                {
                  required: true,
                  message: '请输入租赁起期',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '收费套餐',
              prop: 'ruleId',
              type: 'tree',
              hide: true,
              // disabled: true,
              dicData: [],
              props: {
                label: 'setmealName',
                value: 'id',
              },
              rules: [
                {
                  required: true,
                  message: '请选择收费套餐',
                  trigger: 'blur',
                },
              ],
              span: 8,
            },
            {
              label: '续租时长',
              prop: 'cycleNum',
              span: 8,
              disabled: true,
              hide: true,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
            },
            {
              label: '租赁止期',
              prop: 'buyEndTime',
              type: 'date',
              width: 100,
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 23:59:59',
              span: 8,
              rules: [
                {
                  required: true,
                  message: '请输入租赁止期',
                  trigger: 'change',
                },
                {
                  validator: (rule, value, callback) => {
                    var dateStart = Date.parse(this.form.buyStartTime);
                    var dateEnd = Date.parse(value);
                    if (dateStart >= dateEnd) {
                      callback(new Error('租赁止期必须大于租赁起期！'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'change',
                },
              ],
            },
            {
              label: '收费套餐',
              prop: 'ruleName',
              display: false,
              addDisplay: false,
            },
            {
              label: '应收金额',
              prop: 'shouldMoney',
              precision: 2,
              width: 70,
              hide: true,
              maxlength: 11,
              showWordLimit: true,
              disabled:true,
              mock: {
                type: 'number',
                max: 1,
                min: 2,
                precision: 2,
              },
              rules: [
                {pattern: /^\d+(\.\d+)?$/, message: '格式错误'},
              ],
              minRows: 0.01,
              span: 8,
            },
            {
              label: '支付金额',
              prop: 'payMoney',
              width: 70,
              span: 8,
              precision: 2,
              maxlength: 11,
              showWordLimit: true,
              disabled:true,
              hide: true,
              mock: {
                type: 'number',
                max: 1,
                min: 2,
                precision: 2,
              },
              minRows: 0.01,
              rules: [
                {pattern: /^\d+(\.\d+)?$/, message: '格式错误'},
              ],
            },
            {
              label: '客户姓名',
              span: 8,
              prop: 'customerName',
              width: 70,
              search: true,
              maxlength: 10,
              disabled: true,
              showWordLimit: true,
              rules: [
                {
                  required: true,
                  message: '请输入客户姓名',
                  trigger: 'blur',
                },
              ],
            },
            {
              label: '客户手机',
              prop: 'customerPhone',
              search: true,
              width: 100,
              span: 8,
              disabled: true,
              rules: [
                {
                  required: true,
                  message: '请输入手机号',
                  trigger: 'blur',
                },
              ],
            },
            {
              label: '车位编号',
              prop: 'lotNo',
              hide: true,
              span: 8,
              disabled: true,
              maxlength: 30,
              showWordLimit: true,
              rules: [
                {
                  required: false,
                  message: '请输入停车车位编号',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '状态',
              prop: 'status',
              search: true,
              width: 70,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              span: 8,
              // editDisplay: false,
              addDisplay: false,

            },
            {
              label: '支付方式',
              hide: true,
              addDisplay: false,
              editDisplay: false,
              prop: 'payType',
              disabled: true,
              span: 8,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              rules: [
                {
                  required: true,
                  message: '请输入支付方式',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '支付时间',
              prop: 'payTime',
              span: 8,
              width: 150,
              hide: true,
              type: 'date',
              display: false,
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editDisabled: true,
            },

            {
              // 此column不展示，用做接受选择车牌后返回的房间id数据，新增后存入数据库
              //lazy: true,
              label: '房间',
              prop: 'areaId',
              type: 'tree',
              hide: true,
              span: 16,
              display: false,
            },
            {
              label: '房间',
              prop: 'areaName',
              hide: true,
              span: 16,
              disabled: true,
            },
            {
              label: '电子资料',
              prop: 'imgUrl',
              hide: true,
              type: 'upload',
              listType: 'picture-img',
              propsHttp: {
                res: 'data',
                url: 'link',
              },
              action: '/api/v4ward/oss/customEndpoint/put-file',
              tip: '只能上传jpg/png格式的图片，且不超过500kb',
              span: 24,
              row: true,
            },
            {
              label: '备注',
              prop: 'remark1',
              type: 'textarea',
              hide: true,
              span: 24,
              maxlength: 200,
              showWordLimit: true,
              minRows: 2,
              overHidden: true,
              rules: [
                {
                  required: false,
                  message: '办公车辆请输入备注说明',
                  trigger: 'change',
                },
              ],
            },
            {
              addDisplay: false,
              editDisplay: false,
              label: '操作日志',
              prop: 'info',
              span: 24,
              hide: true,
              formslot: true,
            },
            {
              label: '租赁起期',
              prop: 'dateStartRange',
              span: 24,
              searchslot:true,
              search: true,
              searchRange: true,
              hide: true,
              display: false,
              type: 'daterange',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
            },
            {
              label: '租赁止期',
              prop: 'dateEndRange',
              searchslot:true,
              searchSpan: 6,
              search: true,
              searchRange: true,
              hide: true,
              display: false,
              type: 'daterange',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
            },
            // {
            //   label: '支付时间',
            //   prop: 'payTimeRange',
            //   searchslot:true,
            //   searchSpan: 6,
            //   search: true,
            //   searchRange: true,
            //   hide: true,
            //   type: 'daterange',
            //   display: false,
            //   format: 'yyyy-MM-dd',
            //   valueFormat: 'yyyy-MM-dd',
            // },
          ],
        },
        infoOption: {
          addBtn: false,
          menu: false,
          border: true,
          column: [
            {
              label: '操作类型',
              prop: 'operateType',
              type: 'select',
              dicData: [
                {
                  label: '月卡车审核',
                  value: 1,
                },
                {
                  label: '新增月卡车',
                  value: 2,
                },
                {
                  label: '修改月卡车',
                  value: 6,
                },
                {
                  label: '月卡车退费',
                  value: 4,
                },
                /*  {
                  label: '车辆续约',
                  value: 5,
                },*/
                {
                  label: '变更车牌',
                  value: 3,
                },
                {
                  label: '删除过期车辆',
                  value: 7,
                },
                {
                  label: '月卡车信息已同步至岗亭',
                  value: 8,
                },
                {
                  label: '补缴月卡车更新临停记录',
                  value: 9,
                },
              ],
            },
            {
              label: '操作内容',
              prop: 'operateContent',
              width: 400,
            },
            {
              label: '操作人',
              width: 100,
              prop: 'remark3',
            },
            {
              label: '操作时间',
              prop: 'createTime',
            },
          ],
        },
        unPayOption: {
          addBtn: false,
          menu: false,
          border: true,
          columnBtn: false,
          refreshBtn: false,
          align: 'center',
          column: [
            {
              label: '停车场',
              prop: 'spaceName',
              width: 110,
            },
            {
              label: '车牌号',
              prop: 'carNo',
              width: 90,
            },
            {
              label: '欠费（元）',
              prop: 'bankMoney',
            },
            {
              label: '停车时长（时）',
              prop: 'parkTime',
            },
            {
              label: '入场时间',
              prop: 'inTime',
              searchSpan: 6,
              width: 130,
              type: 'datetimerange',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            {
              label: '出场时间',
              prop: 'outTime',
              type: 'datetimerange',
              searchRange: true,
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              width: 130,
            },
            {
              label: '应缴（元）',
              prop: 'payableMoney',
            },
            {
              label: '实收（元）',
              prop: 'chargeMoney',
            },
          ],
        },
        unPayData: [],
        data: [],
        noWatchNum:0,
      };
    },
    components: {carMonthExport,carmonthReniorForm},
    // created(){
    // },
    watch: {
      'form.buyStartTime'() {
        const ruleIdColumn = this.findObject(this.option.column, 'ruleId');
        if (
          this.form.buyStartTime != undefined &&
          this.form.buyStartTime != '' &&
          this.form.buyStartTime != null &&
          this.form.spaceId != ''
        ) {
          ruleIdColumn.disabled = false;
        } else {
          this.form.ruleId = '';
          // ruleIdColumn.disabled = true;
        }
      },
      'form.spaceId'() {
        this.getAreNodeList(this.form.spaceId);
        //解决进入修改页面时，月客车规则下拉为空问题
        if (this.form.spaceId != null && this.form.spaceId != '' && this.form.spaceId != undefined) {
          monthChargeRuleList(Object.assign({spaceId: this.form.spaceId})).then(({data}) => {
            const column = this.findObject(this.option.column, 'ruleId');
            column.dicData = data;
          });
        }
      },
      'form.ruleId'() {
        const cycleNumColumn = this.findObject(this.option.column, 'cycleNum');
        //将时间格式转换为字串
        let buyStartTimeStr = this.form.buyStartTime + '';
        if (this.vdui.isNotEmpty(buyStartTimeStr) && this.vdui.isNotEmpty(this.form.ruleId)) {
          cycleNumColumn.disabled = false;
        } else {
          this.form.cycleNum = '';
          cycleNumColumn.disabled = true;
        }
      },
      'form.carClass'() {
        const remark1Column = this.findObject(this.option.column, 'remark1');
        if (this.form.carClass == 2) {
          remark1Column.rules[0].required = true;
          this.form.shouldMoney = 0;
          this.form.payMoney = 0;
        } else {
          remark1Column.rules[0].required = false;
          this.initShoudMoney();
        }
      },
      'form.cycleNum'() {
        this.initShoudMoney();
      },

      'form.shouldMoney'() {
        const column = this.findObject(this.option.column, 'shouldMoney');
        if (this.form.status == 3 || this.form.status == 2) {
          column.editDisabled = true;
        } else {
          column.editDisabled = false;
        }
      },
      'form.payMoney'() {
        const column = this.findObject(this.option.column, 'payMoney');
        if (this.form.status == 3 || this.form.status == 2) {
          column.editDisabled = true;
        } else {
          column.editDisabled = false;
        }
      },
      //用于监听新增车场关联区域
      /* 'form.spaceId'(){
         this.form.regionId = '';
         let parkingLotIdTem = this.form.spaceId;
         if (this.vdui.isNotEmpty(parkingLotIdTem)) {
           this.getAreNodeList(this.form.spaceId);
         }
         nodeTreeByParentId(this.carMonthCopyForm.spaceId ).then((res) => {
           const column = this.findObject(this.carMonthCopyOption.column, 'regions');

           setTimeout(()=>{
             column.dicData = res.data;
           });
         })

       },*/

      //用于监听复制车场关联区域
      'carMonthCopyForm.spaceId'() {

        nodeTreeByParentId(this.carMonthCopyForm.spaceId).then((res) => {
          const column = this.findObject(this.carMonthCopyOption.column, 'regions');

          setTimeout(() => {
            column.dicData = res.data;
          });
        })
      }
    },
    computed: {
      ...mapGetters(['permission', 'userInfo']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.carmonthRenior_add, false),
          copyBtn: this.vaildData(this.permission.carmonth_copy, false),
          syncPlusBtn: this.vaildData(this.permission.carmonth_synchronize_plus, false),
        };
      },
      infoData() {
        return this.form.info;
      },
      ids() {
        let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    mounted() {
    },
    created() {
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          this.option.column[0].dicData = data.data;
          this.option.column[0].searchValue = this.spaceList[0].id;
          this.query.spaceId = this.spaceList[0].id;
          this.tempSpaceId = this.spaceList[0].id;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },
    methods: {
      openFormDialog(row,type){
        this.$refs.carmonthReniorForm.openDialog(row,type)
      },
      selectTempStopUnPayList(spaceId, carNo) {
        // 查询临停欠费记录
        getListTempStopUnPayList({spaceId: this.form.spaceId, carNo: this.form.carNo}).then(
          ({data}) => {
            this.unPayData = data;
          }
        );
        this.tempStopUnPayDialogFlag = true;
      },
      carNohandleBlur() {
        if (this.vdui.isNotEmpty(this.form.carNo)) {
          if (this.vdui.isNotEmpty(this.form.spaceId)) {
            let backAmountTemp = 0;
            this.form.customerPhone = '';
            this.form.customerName = '';
            this.form.lotNo = '';
            this.form.areaName = '';
            this.form.areaId = '';
            //查询欠费
            loadCarPayBackAmount({communityId: this.form.spaceId, carNo: this.form.carNo}).then(
              ({data}) => {
                backAmountTemp = Number(data.carPayBackAmount);
                //  start-----getcarMonthLastEndTime
                getcarMonthLastEndTime({spaceId: this.form.spaceId, carNo: this.form.carNo}).then(
                  ({data}) => {
                    if (this.vdui.isNotEmpty(data)) {
                      this.form.lastEndTime = data.buyEndTime;
                      this.form.buyStartTime = data.newStartTime + ' 00:00:00';
                      this.form.carType = data.carType;
                      if (this.vdui.isNotEmpty(data.regions)) {
                        this.form.regions = data.regions;
                      }
                      this.form.ruleId = data.ruleId;
                      this.form.backAmount = backAmountTemp;
                    } else {
                      let spaceIdTemp = this.form.spaceId;
                      let carNoTemp = this.form.carNo;
                      //若没查到则清空表单
                      this.emptyForm();
                      if (this.vdui.isEmpty(this.form.regions)) {
                        this.form.regions = this.regionFirstIdTemp;
                      }
                      if (backAmountTemp > 0) {
                        this.form.backAmount = backAmountTemp;
                      }
                      this.form.spaceId = spaceIdTemp;
                      this.form.carNo = carNoTemp;
                      this.form.buyStartTime = this.getInitData();
                    }
                  }
                );
              }
            );
          } else {
            this.$message.error('请先选择车场！');
            this.form.carNo = '';
          }
        } else {
          let spaceIdTemp = this.form.spaceId;
          this.emptyForm();
          this.form.spaceId = spaceIdTemp;
          this.form.buyStartTime = this.getInitData();
        }
      },
      selectSpace() {
        // l临时变量
        let spaceIdTempOne = this.form.spaceId;
        this.emptyBasePerson();
        this.emptyForm();
        this.form.spaceId = spaceIdTempOne;
        const ruleIdColumn = this.findObject(this.option.column, 'ruleId');
        if (this.vdui.isNotEmpty(this.form.spaceId)) {
          if (this.form.buyStartTime != '') {
            ruleIdColumn.disabled = false;
          } else {
            this.form.ruleId = '';
            // ruleIdColumn.disabled = true;
          }
          monthChargeRuleList(Object.assign({spaceId: this.form.spaceId})).then(({data}) => {
            if (data.length == 0) {
              this.$message.error('该车场下未查询到月卡车收费规则！');
            }
            const column = this.findObject(this.option.column, 'ruleId');
            column.dicData = data;
          });
        }
      },
      //初始化化应收金额
      initShoudMoney() {
        if(this.dialogType == 'view'){
          return;
        }
        if (this.vdui.isNotEmpty(this.form.cycleNum)) {
          if (this.vdui.isEmpty(this.form.ruleId)) {
            this.$message.error('收费规则不得为空');
            return;
          }
          loadCarPayAmount({
            ruleId: this.form.ruleId,
            cycleNum: this.form.cycleNum,
            startTime: this.form.buyStartTime,
            backAmount: this.form.backAmount,
            backType: 3,
          }).then(({data}) => {
            //若为办公车则应收实收金额为0
            if (this.form.carClass == 2) {
              this.form.shouldMoney = 0;
              this.form.payMoney = 0;
            } else {
              this.form.shouldMoney = data.shouldAmount;
              this.form.payMoney = data.shouldAmount;
            }
            if(this.changeBuyEndTime){
              this.form.buyEndTime = data.endTime + ' 23:59:59';
            }
          });
        } else {
          if (!this.form.shouldMoney) {
            this.form.shouldMoney = 0;
          }
          if (!this.form.payMoney) {
            this.form.payMoney = 0;
          }
          return;
          // this.form.shouldMoney = 0;
        }
      },
      //获取区域节点数据
      getAreNodeList(parentId) {

        this.form.regions = '';
        nodeTreeByParentId(parentId).then((res) => {
          const regionsColumn = this.findObject(this.option.column, 'regions');
          if (this.operateType === 'add') {
            this.form.regionId = "";

          }
          regionsColumn.dicData = res.data;
          if (this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(regionsColumn.dicData)) {
            if (this.addFlag) {
              this.form.regions = regionsColumn.dicData[0].id;
              // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
              this.regionFirstIdTemp = regionsColumn.dicData[0].id;

            } else {
              this.form.regions = '';
            }
          }
        });
      },
      //查询车牌号
      queryCarPayMonthCarNo(qs, cb) {
        loadCarPayMonthCarNo({communityId: this.form.spaceId, searchContent: qs}).then(
          ({data}) => {
            if (this.vdui.isEmpty(data)) {
              cb([]);
              if (this.vdui.isNotEmpty(this.form.spaceId)) {
                this.$message.info('没有匹配到车辆信息！');
                this.form.carNo = '';
              }
            } else {
              this._.forEach(data, (item) => {
                item.value = item.carNo;
              });
              cb(data);
            }
          }
        );
      },
      //选择车牌号
      selectCarPayCarNo(item) {
        if (
          this.form.buyStartTime != undefined &&
          this.form.buyStartTime != '' &&
          this.form.buyStartTime != null &&
          this.form.spaceId != ''
        ) {
          const ruleIdColumn = this.findObject(this.option.column, 'ruleId');
          ruleIdColumn.disabled = false;
        }


        this.form.carNo = item.carNo;
        this.form.customerPhone = item.customerPhone;
        this.form.customerId = item.customerId;
        this.form.customerName = item.customerName;
        this.form.lotNo = item.lotNo;
        this.form.areaName = item.areaName;
        this.form.areaId = item.areaId;
      },
      //月卡车审核
      openCarMonthReviewDialog() {
        const carTypeColumn = this.findObject(this.carMonthReviewOption.column, 'carType');
        carTypeColumn.display = true;
        if (this.selectionList.length !== 1 || this.selectionList[0].$status !== '待审核') {
          this.$message.warning('请选择一条[待审核]数据进行操作');
          return;
        }
        this.carMonthReviewForm = this.selectionList[0];
        this.buyStartTimeTemp = this.carMonthReviewForm.buyStartTime;
        this.buyEndTimeTemp = this.carMonthReviewForm.buyEndTime;
        //carClass==2则为临时车，不显示车辆类型
        if (this.carMonthReviewForm.carClass == 2) {
          carTypeColumn.display = false;
        }
        this.carMonthReviewShowDialogFlag = true;
      },
      quitCarMonthReviewDialog(form, done) {
        this.carMonthReviewShowDialogFlag = false;
        this.$refs.carMonthReviewFormRef.resetForm();
      },
      //审核通过
      carMonthReviewSubmit(form, done) {
        this.$refs.carMonthReviewFormRef.validate((valid) => {
          if (valid) {
            //若为免费车，则状态直接变为3：正常
            if (form.carClass == 2) {
              form.status = 3;
            }
            //若为月卡车，则状态变为2：待付款
            if (form.carClass == 1) {
              form.status = 2;
            }
            form.operateType = 1;
            update(form).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.carMonthReviewShowDialogFlag = false;
                this.$refs.carMonthReviewFormRef.resetForm();
                done();
              },
              (error) => {
                console.log(error);
              }
            );
          }
        });
      },
      //审核驳回
      rejectCarMonthReviewDialog(form, done) {
        form = this.carMonthReviewForm;
        this.$refs.carMonthReviewFormRef.validate((valid) => {
          if (valid) {
            form.status = 1;
            form.operateType = 1;
            update(form).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.carMonthReviewShowDialogFlag = false;
                this.$refs.carMonthReviewFormRef.resetForm();
                done();
              },
              (error) => {
                console.log(error);
              }
            );
          }
        });
      },
      //月卡车牌变更
      openCarMonthChangeDialog(form, done) {
        if (this.selectionList.length !== 1) {
          this.$message.warning('请选择一条数据进行操作');
          return;
        }
        this.carMonthChangeForm = this.selectionList[0];
        this.carMonthChangeForm.newCarNo = '';
        this.carMonthChangeShowDialogFlag = true;
      },
      quitCarMonthChangeDialog(form, done) {
        this.carMonthChangeShowDialogFlag = false;
        this.$refs.carMonthChangeFormRef.resetForm();
      },
      carMonthChangeSubmit(form, done) {
        this.$refs.carMonthChangeFormRef.validate((valid) => {
          if (valid) {
            form.operateType = 3;
            if (form.carNo === form.newCarNo) {
              this.$message.success('输入新车牌号与修改前一样!');
              this.carMonthChangeForm.newCarNo = ' ';
              done();
              return;
            }
            form.newCarNo = form.newCarNo.trim();
            update(form).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.carMonthChangeShowDialogFlag = false;

                this.$refs.carMonthChangeFormRef.resetForm();
                done();
              },
              (error) => {
                console.log(error);
                done();
              }
            );
          }
        });
      },
      //月卡车退费
      openCarMonthRefundDialog() {
        if (this.selectionList[0].carClass == 2) {
          this.$message.warning('免费车不允许退款，请重新操作！');
          return;
        }
        if (this.selectionList.length !== 1 || this.selectionList[0].$status !== '正常') {
          this.$message.warning('请选择一条[正常]数据进行操作！');
          return;
        }
        getDetail({id: this.selectionList[0].id}).then(({data}) => {
          this.carMonthRefundForm = data;
          this.carMonthRefundShowDialogFlag = true;
          // let day1 = new Date();
          // this.carMonthRefundForm.buyEndTime = day1.toISOString().slice(0, 10) + ' 23:59:59';
          this.carMonthRefundForm.buyEndTime = data.buyEndTime;
          this.carMonthRefundForm.returnMoney = 1;
        });
      },
      isAdmin() {
        var account = this.userInfo.account;
        if (this.vdui.isEmpty(account)) {
          return false;
        }
        return account.includes('admin');
      },
      openMonthCarEmportForm() {
        this.importMonthCarForm.parkId = this.query.spaceId;
        this.showImportDialog = true;
      },
      downloadTemplate() {
        window.open(`/api/v4ward/car/CarMonth/downTemplate?Blade-Auth=${getToken()}&parkId=` + this.query.spaceId);
      },
      exportMonthCar(f) {
        const formData = new FormData();
        formData.append('parkId', this.importMonthCarForm.parkId);
        formData.append('file', f.file);
        this.importButtonDisabled = true;
        exportMonthCarList(formData)
          .then((response) => {
            if (response.code === 200) {
              this.$message.success('上传成功!');
              this.importMonthCarForm = {};
              this.showImportDialog = false;
              this.importButtonDisabled = false;
              this.selectFileDisabled = false;
              this.onLoad();
            }
          }).catch(() => {
            var parkId = this.importMonthCarForm.parkId;
            this.importMonthCarForm = {
              parkId: parkId,
              fileName: '',
            };
            this.importButtonDisabled = false;
            f.onError();
        });
      },

      uploadMonthCar() {
        this.$refs['importMonthCarForm'].validate((valid) => {
          if (valid) {
            this.$refs.upload.submit();
          }
        });
      },
      cancelUploadMonthCar() {
        console.log('取消上传...');
        var parkId = this.importMonthCarForm.parkId;
        this.importMonthCarForm = {
          parkId: parkId,
          fileName: '',
        };
        this.showImportDialog = false;
        this.selectFileDisabled = false;
        this.importButtonDisabled = false;
      },
      handleRemove(){
        this.selectFileDisabled = false;
      },
      loadJsonFromFile(file,fileList) {
        if(fileList.length > 0){
          this.importMonthCarForm.fileName = file.name;
        }
        this.$refs['importMonthCarForm'].validate();
        this.selectFileDisabled = (fileList.length >0);
      },
      quitCarMonthRefundDialog(form, done, loading) {
        this.carMonthRefundShowDialogFlag = false;
        this.refundCheckReturnMoney = true;
        this.refundCheckBuyEndTime = true;
        this.$refs.carMonthRefundFormRef.resetForm();
      },
      carMonthRefundSubmit(form, done) {
        if (!this.refundCheckReturnMoney) {
          this.$message.error('请检查退费金额!');
          done();
          return;
        }
        if (!this.refundCheckBuyEndTime) {
          this.$message.error('请检查租赁止期!');
          done();
          return;
        }
        this.$refs.carMonthRefundFormRef.validate((valid) => {
          if (valid) {
            form.operateType = 4;
            form.buyEndTime = form.buyEndTime.substring(0,10)+" 23:59:59";
            var dateStart = Date.parse(form.buyStartTime);
            var dateEnd = Date.parse(form.buyEndTime);
            if (dateStart > dateEnd) {
              this.$message.error('租赁止期必须大于等于租赁起期！');
              done();
              return;
            }
            update(form).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.carMonthRefundShowDialogFlag = false;
                this.$refs.carMonthRefundFormRef.resetForm();
                done();
              },
              (error) => {
                console.log(error);
                done();
              }
            );
          }
        });
      },
      rowSave(row, loading, done) {

        addRenior(row).then(
          () => {
            this.$message.success('操作成功!');
            //清空上一表单数据
            let spaceIdTemp = this.form.spaceId;
            //this.form.regions = this.regionFirstIdTemp;
            this.form.regions = '';
            this.form.buyStartTime = this.getInitData();
            this.emptyForm();
            // 清空车主基本信息
            this.emptyBasePerson();
            this.form.spaceId = spaceIdTemp;
            this.addFlag = false;
            this.onLoad();
            done();
          },
          (error) => {
            window.console.log(error);
            done();
          }
        );
      },
      //自定义清空表单
      emptyForm() {
        this.form.spaceId = '';
        this.form.carNo = '';
        this.form.carClass = 1;
        this.form.carType = '';
        this.form.lastEndTime = '';
        this.form.backAmount = 0;
        this.form.ruleId = '';
        this.form.cycleNum = '';
        this.form.buyEndTime = '';
        this.form.shouldMoney = 0;
        this.form.payMoney = 0;
        //this.form.regions = this.regionFirstIdTemp;
        this.form.regions = '';
        this.form.imgUrl = '';
        this.form.remark1 = '';
        this.form.buyStartTime = this.getInitData();
      },
      // 新增后，清空车主基本信息
      emptyBasePerson() {
        this.form.customerName = '';
        this.form.customerPhone = '';
        this.form.areaId = '';
        this.form.areaName = '';
        this.form.lotNo = '';
      },
      rowUpdate(row, index, loading, done) {
        if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
          row.regions = '';
        }
        if (!row.imgUrl) {
          row.imgUrl = '';
        }
        update(row).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            loading();
            this.emptyForm();
          },
          (error) => {
            window.console.log(error);
            done();
          }
        );
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      openCarMonthSynDialog() {
        let exeFlag = true;
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        for (let i = 0; i < this.selectionList.length; i++) {
          if (this.selectionList[i].status != 3) {
            this.$message.error('请选择状态为正常的月卡车数据');
            exeFlag = false;
            break;
          }
        }
        if (exeFlag) {
          this.$confirm('确定将选择进行同步?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.loading = true;
              return synchronize({ids: this.ids});
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.$refs.crud.toggleSelection();
            });
          this.loading = false;
        }
      },
      carMonthSyncPlus() {
        this.$confirm('确定将选择进行同步?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.loading = true;
          return synchronizePlus({ spaceId: this.syncSpaceId });
        }).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
        this.loading = false;
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      openFullScreen2() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      },
      beforeOpen(done, type) {
        //打开窗口前先将新增标识符置位false，后面根据打开的数新增窗口时将其置为true
        this.addFlag = false;

        // const regionsColumn = this.findObject(this.option.column, 'regions');
        // regionsColumn.dicData = [];
        const areaIdColumn = this.findObject(this.option.column, 'areaId');
        areaIdColumn.span = 16;
        areaIdColumn.label = '房间';

        if (['add'].includes(type)) {
          this.dialogType = 'add'
          this.emptyForm();
          this.form.id = '';
          this.dialogDisabled = false;

          setTimeout(() => {
            this.form.spaceId = this.searchForm.spaceId;
            this.form.lastEndTime = '';
            this.form.buyStartTime = this.getInitData();
            this.form.ruleId = '';
            this.form.carClass = 1;
            this.form.regions = '';
          }, 0);
          //打开的是新增页面标识
          this.addFlag = true;
          this.changeBuyEndTime = true;
        }
        if (['edit', 'view'].includes(type)) {
          this.changeBuyEndTime = false;
          //修改页面变更字段label名称
          areaIdColumn.span = 8;
          areaIdColumn.label = '修改房间';
          this.dialogDisabled = true;
          //  对历史数据造成的bug修改
          if (this.form.ruleId == -1) {
            this.form.ruleId = '';
          }
          this.form.backAmount = '';
          // 详情页展示操作日志
          if (['view'].includes(type)) {
            this.dialogType = 'view'
            getDetailAndOperate({id: this.form.id}).then(({data}) => {
              this.form.info = data.carMonthLogList;
              setTimeout(() => {
                let _el = document.querySelector(
                  'div[id*="el-collapse-content"] > div > div > div:nth-child(17) > div > div > div > div.avue-upload.avue-upload--list.avue-upload--upload > div.el-upload.el-upload--picture-img'
                );
                _el.style.display = 'inline-block';
                _el.addEventListener('click', (e) => {
                  setTimeout(() => {
                    _el.querySelector('div>div>span>i').style.color = '#fff';
                  });
                });
              });
            });
          }else{
            this.dialogType = 'edit'
          }
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = this._.cloneDeep(data);
            if (this.vdui.isEmpty(this.form.backAmount)) {
              this.form.backAmount = 0;
            }
          });
        } else {
          setTimeout(() => {
            //console.log(this.query.parkingLotId);
            this.form.spaceId = this.query.spaceId;
          }, 0);
        }
        if (['edit', 'add'].includes(type)){
          const payMoneyColumn = this.findObject(this.option.column, 'payMoney');
          payMoneyColumn.disabled = false;
          const shouldMoneyColumn = this.findObject(this.option.column, 'shouldMoney');
          shouldMoneyColumn.disabled = false;
        }else{
          const payMoneyColumn = this.findObject(this.option.column, 'payMoney');
          payMoneyColumn.disabled = true;
          const shouldMoneyColumn = this.findObject(this.option.column, 'shouldMoney');
          shouldMoneyColumn.disabled = true;
        }
        done();
      },
      searchReset() {
        this.query = {};
        //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
        this.firstDisplayFlag = true;
        this.onLoad();
      },
      submitSearchForm() {
        this.searchChange(this.query);
      },
      searchChange(params, done) {
        this.query.spaceId=params.spaceId
        this.query.carNo=params.carNo
        this.query.customerName=params.customerName
        this.query.customerPhone=params.customerPhone
        this.query.status=params.status
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      getInitData() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month < 10) {
          month = '0' + month;
        }
        if (strDate < 10) {
          strDate = '0' + strDate;
        }
        var currentdate = year + '-' + month + '-' + strDate + ' 00:00:00';
        return currentdate;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if (this.query.dateStartRange) {
          this.query.buyStartTimeStart = this.query.dateStartRange[0];
          this.query.buyStartTimeEnd = this.query.dateStartRange[1];
        }
        if (this.query.dateEndRange) {
          this.query.buyEndTimeStart = this.query.dateEndRange[0];
          this.query.buyEndTimeEnd = this.query.dateEndRange[1];
        }
        if (this.query.payTimeRange) {
          this.query.payTimeStart = this.query.payTimeRange[0];
          this.query.payTimeEnd = this.query.payTimeRange[1];
        }
        //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
        if (this.query.spaceId == undefined || this.query.spaceId == '') {
          this.query.spaceId = this.tempSpaceId;
        }
        if (this.spaceList.length > 0) {
          getMainList(Object.assign({current: page.currentPage, size: page.pageSize}, this.query)).then(
            ({data}) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
              if (this.firstDisplayFlag) {
                let ent = document.querySelector('input[placeholder="车场名称"]');
                ent.value = this.spaceList[0].title;
                this.query.spaceId = this.spaceList[0].id;
                //关闭默然显示，重刷页面时才开启默认显示
                this.firstDisplayFlag = false;
              }
            }
          );
        } else {
          this.loading = false;
        }
      },
      //打开导出弹框
      openExportExcelDialog() {
        this.exportExcelFlag = true;
        this.$refs.exportExcelFormRef.resetForm();
      },
      //按条件导出
      exportExcel(form, done) {
        var values = {...form};
        if(this.query.buyStartTimeStart!=""&&this.query.buyStartTimeEnd!=""){
          values.buyStartTimeStart = this.query.buyStartTimeStart
          values.buyStartTimeEnd = this.query.buyStartTimeEnd;
          values.dateStartRange = null;
        }
        if(this.query.buyEndTimeStart!=""&&this.query.buyEndTimeEnd!=""){
          values.buyEndTimeStart = this.query.buyEndTimeStart
          values.buyEndTimeEnd = this.query.buyEndTimeEnd;
          values.dateEndRange = null;
        }
        if(this.query.payTimeStart!=""&&this.query.payTimeEnd!=""){
          values.payTimeStart = this.query.payTimeStart
          values.payTimeEnd = this.query.payTimeEnd;
          values.payTimeRange = null;
        }
       
        this.$refs.carMonthExport.carMonthExportExcel(values);
        done();
      },
      uploadBefore(file, done, loading) {
        // console.log(file.name.split('.'));
        let len = file.name.split('.').length;
        // console.log(file.name.split('.')[len-1]);
        console.log(
          file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpeg'
        );
        console.log(file.type === 'image/jpeg' || file.type === 'image/png');
        console.log(file.type);
        const isImage =
          (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
          (file.type === 'image/jpeg' || file.type === 'image/png');
        console.log(isImage);
        const isLt500KB = file.size / 1024 < 500;
        if (!isImage) {
          this.$message.error('只能上传jpg/png格式的图片');
          loading();
          return;
        }
        if (!isLt500KB) {
          this.$message.error('上传图片大小不能超过500kb!');
          loading();
          return;
        }
        if (isImage && isLt500KB) {
          done();
        }
      },

      //打开复制月卡车弹框
      openCarmonthCopyDialog() {
        this.carMonthCopyShowDialogFlag = true;
        console.log(this.selectionList.length);
        if (this.selectionList.length == 0) {
          this.$message.warning('请最少选择一条需要复制的车辆');
          this.carMonthCopyShowDialogFlag = false;
          return;
        }
        //初始化复制月卡车页面
        //this.carMonthCopyForm = this.deepClone(this.selectionList[0]);
        this.carMonthCopyForm.spaceId = this.selectionList[0].parkingLotId;

        //用于复制月卡车页面区域数据
        //console.log("this.selectionList[0].spaceId===>",this.selectionList[0].spaceId);
        nodeTreeByParentId(this.selectionList[0].spaceId).then((res) => {
          const column = this.findObject(this.carMonthCopyOption.column, 'regions');
          console.log(column);
          setTimeout(() => {
            column.dicData = res.data;
          });

          /*if (this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(column.dicData)) {
            if (this.addFlag) {
              this.form.regions = column.dicData[0].id;
              // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
              this.regionFirstIdTemp = column.dicData[0].id;
            } else {
              this.form.regions = '';
            }
          }*/
        });
      },
      //退出复制月卡车
      quitCarMonthCopyDialog(form, done) {
        this.carMonthCopyShowDialogFlag = false;
        this.$refs.CarMonthCopyFormRef.resetForm();
        this.onLoad();
      },

      //复制月卡车保存
      carMonthCopySubmit(form, done) {
        //console.log(form);
        //console.log(this.selectionList);
        let idList = [];
        this.selectionList.forEach((e, i) => {
          idList.push(e.id);
        });

        //console.log(form.regions.length);

        let form_ = {
          ids: idList.join(','),
          spaceId: form.spaceId,
          //regionId:form.regions.length || '',
          regionId: form.regions.length == 0 ? '' : form.regions,
        };
        //console.log(form_);
        // return;
        //调用复制月卡车凭证接口
        copyCarmonth(form_).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.carMonthCopyShowDialogFlag = false;
            this.$refs.carMonthCopyFormRef.resetForm();
            done();
          },
          (error) => {
            done();
            console.log(error);
          },
        );


      },

    },
  };
</script>

<style>

</style>
